// extracted by mini-css-extract-plugin
export var card = "_tz-0";
export var details = "_tz-1";